var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:({ 'border-radius': _vm.isSimulation ? _vm.borderRadius : 0,
    top: !_vm.isInverted ? '860px' : '73px'
  })},[(_vm.images)?_c('v-carousel',{key:_vm.id,style:({    
      'border-radius': _vm.isSimulation ? _vm.borderRadius : 0,
      'height': _vm.isMenu ? 'calc(90vh)' : '100%'
    }),attrs:{"continuous":"","cycle":!_vm.isSimulation,"hide-delimiters":"","show-arrows":false,"height":"980px"}},_vm._l((_vm.images),function(item,i){return _c('v-carousel-item',{key:item,staticStyle:{"height":"100%"},attrs:{"src":item}})}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }